<script>
	import { base } from '$app/paths';
	import Logo from './Logo.svelte';
	import { campaignsExpanded, nav } from './stores/nav';

	export let nested = false;

	let footer;

	$: !nested && footer && footer.toggleAttribute('inert', $nav);
</script>

<footer
	class="px-5 md:px-6 pt-6 text-sm-fluid"
	class:border-t={!nested}
	class:mt-24={!nested}
	class:pb-6={nested}
	class:pb-18={!nested}
	class:opacity-20={$campaignsExpanded}
	bind:this={footer}
>
	<div class="flex flex-col md:flex-row space-y-8 md:space-y-0 -mx-2">
		<div class="flex-1 px-2">
			<Logo animate={false} />
		</div>

		<div class="flex-2 flex flex-col space-y-5 lg:space-y-0 lg:flex-row">
			<div class="flex-1 px-2">
				<a href="mailto:crowdsourcing@wienbibliothek.at" rel="external"
					>crowdsourcing@wienbibliothek.at</a
				><br />
				<a href="tel:+431400084920" rel="external">+43 (0) 1 4000-84920</a><br />
				Felderstraße 1, 1082 Wien
			</div>

			<ul class="flex-1 px-2">
				<li>
					<a href="https://www.wienbibliothek.at//" target="_blank" rel="noreferrer"
						>Wienbibliothek im Rathaus</a
					>
				</li>
				<li>
					<a href="https://digital.wienbibliothek.at/" target="_blank" rel="noreferrer"
						>Wienbibliothek Digital</a
					>
				</li>
			</ul>
		</div>

		<div class="lg:flex-1 px-2 flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-start">
			<!-- svelte-ignore component-name-lowercase -->
			<nav class="flex-1">
				<ul>
					<li>
						<a href="{base}/datenschutz">Datenschutz</a>
					</li>
					<li>
						<a href="{base}/impressum">Impressum</a>
					</li>
					<li>
						<a href="{base}/nutzungsbedingungen">Nutzungsbedingungen</a>
					</li>
					<li>
						<a href="{base}/barrierefreiheit">Barrierefreiheit</a>
					</li>
				</ul>
			</nav>
			<ul class="flex space-x-6 items-center lg:ml-auto">
				<li>
					<a
						href="https://www.facebook.com/wienbibliothek"
						target="_blank"
						rel="noreferrer"
					>
						<span class="sr-only">Facebook</span>
						<svg aria-hidden="true" focusable="false" width="12.995" height="25">
							<use xlink:href="#icon-facebook" />
						</svg>
					</a>
				</li>
				<li>
					<a
						href="https://www.instagram.com/wienbibliothek/"
						target="_blank"
						rel="noreferrer"
					>
						<span class="sr-only">Instagram</span>
						<svg aria-hidden="true" focusable="false" width="27.249" height="27.254">
							<use xlink:href="#icon-instagram" />
						</svg>
					</a>
				</li>
			</ul>
		</div>
	</div>
</footer>

<style lang="postcss">
	.flex-2 {
		flex: 2;
	}
</style>
